/*
 * GSTR9New DataUpload Constants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'gstr9new/DataUpload' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'gstr9new/DataUpload/YOUR_ACTION_CONSTANT';
 */

// Data upload specific actions
export const UPLOAD_OUTWARD_FILE = 'gstr9new/DataUpload/UPLOAD_OUTWARD_FILE';
export const UPLOAD_INWARD_FILE = 'gstr9new/DataUpload/UPLOAD_INWARD_FILE';
export const DOWNLOAD_TEMPLATE = 'gstr9new/DataUpload/DOWNLOAD_TEMPLATE';

// Upload status tracking
export const SET_UPLOAD_PROGRESS = 'gstr9new/DataUpload/SET_UPLOAD_PROGRESS';
export const SET_UPLOAD_STATUS = 'gstr9new/DataUpload/SET_UPLOAD_STATUS';

// File management
export const SET_SELECTED_FILE = 'gstr9new/DataUpload/SET_SELECTED_FILE';
export const CLEAR_SELECTED_FILE = 'gstr9new/DataUpload/CLEAR_SELECTED_FILE';

// Upload history and records
export const SET_UPLOAD_HISTORY = 'gstr9new/DataUpload/SET_UPLOAD_HISTORY';
export const FETCH_UPLOAD_RECORDS = 'gstr9new/DataUpload/FETCH_UPLOAD_RECORDS';

// Delete operations
export const DELETE_UPLOAD_RECORD = 'gstr9new/DataUpload/DELETE_UPLOAD_RECORD';

// Pipeline status
export const PIPELINE_STATUS = 'gstr9new/DataUpload/PIPELINE_STATUS';

// Download reports
export const DOWNLOAD_REPORT = 'gstr9new/DataUpload/DOWNLOAD_REPORT';
